import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=4f62fa85&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=4f62fa85&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f62fa85",
  null
  
)

export default component.exports